import {Condition} from './condition';

export class GridColor {
  // highest: Condition;

  constructor(id: number, condition?: Condition) {
    this.gridElementId = id;
    this.voltage = condition ? condition : Condition.NORMAL;
    this.voltageGP = condition ? condition : Condition.NORMAL;
    this.frequency = condition ? condition : Condition.NORMAL;
    this.la = condition ? condition : Condition.NORMAL;
    this.laGP = condition ? condition : Condition.NORMAL;
    this.rpa = condition ? condition : Condition.NORMAL;
    this.efl = condition ? condition : Condition.NORMAL;
  }
  gridElementId: number;
  voltage: Condition;
  voltageGP: Condition;
  frequency: Condition;
  la: Condition;
  laGP: Condition;
  rpa: Condition;
  efl: Condition;

  public static getHighestConditionInArray(conditionArray?: Condition[]): Condition {
    let highestCondition = Condition.NORMAL;
    const mapCondition = new Map([ [Condition.NORMAL, 0], [Condition.ATTENTION, 1], [Condition.PROBLEM, 2] ]);
    const conditionSortMap: Map<number, Condition> = new Map<number, Condition>();
    conditionArray.forEach(cond => {
      conditionSortMap.set(mapCondition.get(cond), cond);
    });
    const index = Array.from( conditionSortMap.keys()).sort((n1: number, n2: number) => n2 - n1)[0];
    highestCondition = conditionSortMap.get(index);
    return highestCondition;
  }

  public getHighestCondition(): Condition {
    let highestCondition = Condition.NORMAL;
    const mapCondition = new Map([ [Condition.NORMAL, 0], [Condition.ATTENTION, 1], [Condition.PROBLEM, 2] ]);
    const conditionArray = [this.voltage, this.voltageGP, this.frequency, this.la, this.laGP, this.rpa, this.efl];
    const conditionSortMap: Map<number, Condition> = new Map<number, Condition>();
   // console.log('conditions: ' + this.voltage + ', ' + this.la + ', ' + this.frequency + ', ' + this.rpa);
    conditionArray.forEach(cond => {
      conditionSortMap.set(mapCondition.get(cond), cond);
    });
    const index = Array.from( conditionSortMap.keys()).sort((n1: number, n2: number) => n2 - n1)[0];
    highestCondition = conditionSortMap.get(index);
    // console.log('met. High: ' + highestCondition);
    return highestCondition;
  }

}
